import { CDN_ORACLE_URL } from "@rista/core/config";

// ─── Components ────────────────────────────────────────────────────────────────────────────
export { NoOffersIcon } from "./components/NoOffersIcon";
export { PersonIcon } from "./PersonIcon";
export { DiscountIcon } from "./components/DiscountIcon";
export { AddIcon } from "./components/AddIcon";
export { BackspaceIcon } from "./components/BackspaceIcon";
export { ChevronLeft } from "./components/ChevronLeft";
export { CheckMarkIcon } from "./CheckMarkIcon";
export { CrossIcon } from "./components/CrossIcon";
export { ChevronRight } from "./components/ChevronRight";
// Direction-aware pair — use these for back/next affordances, not the literal two above.
export { ChevronBack, ChevronForward } from "./components/DirectionalChevron";
export { HeaderGradient } from "./HeaderGradient";
export { HomeIcon } from "./components/HomeIcon";
export { LockIcon } from "./LockIcon";
export { MinusIcon } from "./components/MinusIcon";
export { DietaryIcon, EggIcon, NonVegIcon, VegIcon } from "./components/DietaryIcons";
export type { DietaryIconProps } from "./components/DietaryIcons";
export { RecommendedIcon } from "./components/RecommendedIcon";
export {
  TimerIcon,
  TIMER_ACCENT,
  TIMER_DISC,
  TIMER_DISC_OPACITY,
} from "./components/TimerIcon";
export type { TimerIconProps } from "./components/TimerIcon";
export { TouchIcon } from "./components/TouchIcon";
export { WhatsappIcon } from "./components/WhatsappIcon";
export { default as EyeIcon } from "./components/eyeIcon";
export { default as EyeOffIcon } from "./components/eyeOffIcon";
export { default as SuccessIcon } from "./components/sucessIcon";

// ─── PNG ───────────────────────────────────────────────────────────────────────────────────
// Suffixed `Png` so an image never collides with the component of the same name
// (`EggIcon` above is the component that draws `EggIconPng`).
export { default as AmazonPayPng } from "./png/AmazonPay.png";
export { default as DotpeIconPng } from "./png/DotpeIcon.png";
export { default as EggIconPng } from "./png/EggIcon.png";
export { default as GooglePayPng } from "./png/GooglePay.png";
export { default as PaytmPng } from "./png/Paytm.png";
export { default as PhonepePng } from "./png/Phonepe.png";
export { default as SearchPng } from "./png/Search.png";
export { default as SuccessMarkPng } from "./png/SuccessMark.png";
export { default as UpiPng } from "./png/Upi.png";

export const CardsPng = { uri: `${CDN_ORACLE_URL}/kiosk-edc-mode.jpg` };
export const CashPng = { uri: `${CDN_ORACLE_URL}/kiosk-pay-at-counter.jpg` };
export const CounterPng = { uri: `${CDN_ORACLE_URL}/kiosk-payment-success.jpg` };
export const DealAppliedPng = { uri: `${CDN_ORACLE_URL}/kiosk-offer-applied.jpg` };
export const DineInPng = { uri: `${CDN_ORACLE_URL}/kiosk-dinein-service.jpg` };
export const KioskUpiPng = { uri: `${CDN_ORACLE_URL}/kiosk-upi-mode.jpg` };
export const NoItemsFoundPng = { uri: `${CDN_ORACLE_URL}/kiosk-empty-filter.jpg` };
export const NoOffersImagePng = { uri: `${CDN_ORACLE_URL}/kiosk-no-offers.jpg` };
export const SessionExpiredPng = { uri: `${CDN_ORACLE_URL}/kiosk-session-expired.jpg` };
export const TakeawayPng = { uri: `${CDN_ORACLE_URL}/kiosk-takeaway-service.jpg` };
export const KioskPayWithCard = { uri: `${CDN_ORACLE_URL}/kiosk-pay-with-card.png` };
// ─── SVG ───────────────────────────────────────────────────────────────────────────────────
// ⚠️ These resolve to DIFFERENT things per platform: a URL string on web (CRA's file-loader)
// and a React component on mobile (react-native-svg-transformer in metro.config.js).
export { default as DotpeSvg } from "./svg/dotpe.svg";
export { default as EmptyCartSvg } from "./svg/EmptyCart.svg";
